/** @format */

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Input, Button, message } from 'antd';

// import { isEmail } from '@/utils';
import { connectContext } from '@/components/Context';

import { actions as authActions } from '../../../../reducers/userReducer';
import { login as signInAPI } from '../../../../Api/sign';

import './index.less';

const FORM_NAME_TYPE = {
  email: 'email',
  username: 'username',
  password: 'password',
};

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      username: '',
      password: '',
    };
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleSignInSubmit = this.handleSignInSubmit.bind(this);
    this.sendDustLogInstance = this.props.context.sendDustLogInstance;
  }

  // 处理邮箱、密码、验证码的变化
  handleFormChange(e) {
    if (e.target.name === FORM_NAME_TYPE.email) {
      this.setState({
        username: e.target.value,
        email: e.target.value,
      });
    } else if (e.target.name === FORM_NAME_TYPE.password) {
      this.setState({
        password: e.target.value,
      });
    } else {
      // do nothing
    }
  }

  // 提交注册表单
  async handleSignInSubmit(e) {
    e.preventDefault();
    const { email, username, password } = this.state;

    if (email.length === 0 || username.length === 0 || password.length === 0) {
      message.warning('Email & Password Code cannot be empty!');
      return;
    }

    // 用户尝试登录埋点
    this.sendDustLogInstance.trySignIn({
      username,
    });
    const res = await signInAPI({
      username: email,
      password,
    });
    if (res.code === 0) {
      // 登录埋点
      this.sendDustLogInstance.signIn({
        userId: res.data.id,
        username: res.data.username,
      });

      this.props.login({
        userId: res.data.id,
        username: res.data.username,
        name: res.data.username,
        email: res.data.email,
        userImage: res.data.avatar,
        signature: res.data.signature,
      });
      this.props.loginSuccess({ message: '登录成功' });
    } else {
      message.error(res.error.message || res.message);
    }
  }

  render() {
    return (
      <>
        <div className="form-container">
          <div className="title">Sign In with email</div>
          <div className="subtitle">
            Enter the email address associated with your account and your
            password.
          </div>

          <div className="email-container">
            <div>
              <Form onSubmit={this.handleSignInSubmit}>
                <Form.Item>
                  <Input
                    className={'email-input'}
                    bordered={false}
                    name={FORM_NAME_TYPE.email}
                    placeholder="Email"
                    value={this.state.username}
                    onChange={this.handleFormChange}
                  />
                </Form.Item>
                <Form.Item>
                  <Input
                    className={'email-input'}
                    bordered={false}
                    name={FORM_NAME_TYPE.password}
                    placeholder="Password"
                    value={this.state.password}
                    onChange={this.handleFormChange}
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="continue-button"
                    onClick={this.handleSignInSubmit}>
                    Sign In
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      login: authActions.login,
    },
    dispatch,
  );

SignIn = connect(mapStateToProps, mapDispatchToProps)(SignIn);

export default connectContext(SignIn);
